export const addresses = {
  alphabetProvider:"0x2C35931B0f5b33262A09c0101f12b8F3dcdc0DE5",
}
